import { Component } from 'react';
import PropTypes from 'prop-types';
import { trackEvent } from '../utils/googleAnalytics';
import { EventCategories, EventActions } from '../constants/Analytics';
import { isWaitlisted } from '../containers/Success';

const JOB_SCHEMA = 'iglu:au.com.hipagesgroup.hip/job/jsonschema/1-0-0';

const createJobSchema = job => ({
  schema: JOB_SCHEMA,
  data: {
    job_id: job.id
  }
});

export default class JobContextManager extends Component {
  static propTypes = {
    job: PropTypes.object,
    connections: PropTypes.array,
    category: PropTypes.object,
    location: PropTypes.object
  };

  updateJobContext(job) {
    if (job && typeof window !== 'undefined') {
      window.pageContexts = window.pageContexts || [];
      const contextIndex = window.pageContexts.findIndex(c => c.schema === JOB_SCHEMA);
      if (contextIndex > -1) {
        window.pageContexts.splice(contextIndex, 1);
      }
      window.pageContexts.push(createJobSchema(job));
    }
  }

  sendViewEvent(connections = []) {
    trackEvent(
      EventCategories.SINGLE_JOB_MANAGEMENT,
      EventActions.REPORT_CONNECTIONS,
      `${connections.length} Connections - ${connections.filter(isWaitlisted).length} Waitlisted`,
      null,
      null,
      false
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.job && this.props.job && prevProps.job.id !== this.props.job.id) {
      this.updateJobContext(this.props.job);
      this.sendViewEvent(this.props.connections);
    }
  }

  componentDidMount() {
    this.updateJobContext(this.props.job);
    this.sendViewEvent(this.props.connections);
  }

  render() {
    return false;
  }
}
